// extracted by mini-css-extract-plugin
var _1 = "Inhabitants-modulebutton__Ivwv7";
var _2 = "Inhabitants-modulebuttonText__z2gGE";
var _3 = "Inhabitants-modulepageActions__noxin PageActions-modulePageActions__lL8Sl";
export { _1 as "button", _2 as "buttonText", _3 as "pageActions" }
